<div class="page-wrapper">

  <!-- ═══════════════════════════════ HERO ══════════════════════════════ -->
  <div class="hero-section">
    <div class="hero-illustration-wrapper">
      <div class="hero-illustration">
        <img src="assets/img/company/Group (1).png" alt="Job search illustration" class="hero-img" />
      </div>
    </div>
    <div class="hero-text">
      <h1 class="hero-title">{{ 'userJobList.findYourNewJobToday' | translate }}</h1>
      <p class="hero-subtitle">
        {{ 'userJobList.thousandsOfJobsSubtitle' | translate }}
      </p>
    </div>
  </div>

  <!-- ═══════════════════════════ MAIN LAYOUT ═══════════════════════════ -->
  <div class="joblist-inner">

    <!-- ─────────────────────────── FILTERS PANEL (desktop) ─────────── -->
    <div class="filters">
      <div class="filters-header">
        <h2>{{ 'userJobList.filters' | translate }}</h2>
        <button class="clear-btn" (click)="clearFilters()">{{ 'userJobList.clearAll' | translate }}</button>
      </div>

      <!-- Salary -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.salary' | translate }}</p>
        <div class="rate">
          <div *ngFor="let tab of ['Hourly','Monthly','Yearly']" [class.active]="activeSalaryTab === tab"
            (click)="setSalaryTab($any(tab))">{{ tab }}</div>
        </div>
        <div class="salary-checkboxes">
          <label *ngFor="let opt of currentSalaryOptions" class="check-item">
            <input type="checkbox" [checked]="isSalarySelected(opt)" (change)="toggleSalaryRange(opt)" />
            <span class="checkmark"></span>
            <span class="check-label">{{ opt }}</span>
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Date of Posting -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.dateOfPosting' | translate }}</p>
        <label *ngFor="let opt of dateOptions" class="radio-item">
          <input type="radio" name="datePosting" [value]="opt.value" [(ngModel)]="selectedDatePosting"
            (ngModelChange)="loadJobs()" />
          <span class="radio-mark"></span>
          <span class="check-label">{{ opt.label }}</span>
        </label>
      </div>

      <div class="divider"></div>

      <!-- Work Experience -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.workExperience' | translate }}</p>
        <label *ngFor="let opt of experienceOptions" class="radio-item">
          <input type="radio" name="experience" [value]="opt.value" [(ngModel)]="selectedExperience"
            (ngModelChange)="loadJobs()" />
          <span class="radio-mark"></span>
          <span class="check-label">{{ opt.label }}</span>
        </label>
      </div>

      <div class="divider"></div>

      <!-- Type of Employment -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.typeOfEmployment' | translate }}</p>
        <label *ngFor="let type of employmentOptions" class="check-item">
          <input type="checkbox" [checked]="isEmploymentSelected(type)" (change)="toggleEmploymentType(type)" />
          <span class="checkmark"></span>
          <span class="check-label">{{ type }}</span>
        </label>
      </div>

      <div class="divider"></div>

      <!-- Post Type -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.postType' | translate }}</p>
        <label *ngFor="let opt of postTypeOptions" class="radio-item">
          <input type="radio" name="postType" [value]="opt.value" [(ngModel)]="selectedPostType"
            (ngModelChange)="loadJobs()" />
          <span class="radio-mark"></span>
          <span class="check-label">{{ opt.label }}</span>
        </label>
      </div>

      <div class="divider"></div>

      <!-- Workplace -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.workplace' | translate }}</p>
        <label *ngFor="let opt of workplaceOptions" class="radio-item">
          <input type="radio" name="workplace" [value]="opt.value" [(ngModel)]="selectedWorkplace"
            (ngModelChange)="loadJobs()" />
          <span class="radio-mark"></span>
          <span class="check-label">{{ opt.label }}</span>
        </label>
      </div>
    </div>

    <!-- ─────────────────────────── JOBS COLUMN ──────────────────────── -->
    <div class="jobs" #jobsSection>

      <!-- Mobile toolbar -->
      <div class="mobile-toolbar">
        <h2 class="jobs-count">
          {{ isLoading ? '…' : filteredJobs.length }} {{ 'userJobList.job' | translate }}{{ filteredJobs.length !== 1 ? 's' : '' }}
        </h2>
        <button class="filter-trigger-btn" (click)="openFilters()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
          {{ 'userJobList.filters' | translate }}
          <span class="active-badge" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
        </button>
      </div>

      <!-- Desktop job count with loading indicator -->
      <h5 class="jobs-count desktop-jobs-count">
        <span *ngIf="!isLoading">{{ filteredJobs.length }} {{ 'userJobList.jobs' | translate }}</span>
        <span *ngIf="isLoading" class="count-loading">
          <span class="loading-dot"></span>
          <span class="loading-dot"></span>
          <span class="loading-dot"></span>
        </span>
        <span class="filter-loading-badge" *ngIf="isLoading && activeFilterCount > 0">
          {{ 'userJobList.filtering' | translate }}
        </span>
      </h5>

      <!-- Loading state (skeleton) -->
      <div class="loading-state" *ngIf="isLoading">
        <div class="skeleton-card" *ngFor="let i of [1,2,3]">
          <div class="skeleton-logo"></div>
          <div class="skeleton-body">
            <div class="skeleton-line short"></div>
            <div class="skeleton-line medium"></div>
            <div class="skeleton-line long"></div>
            <div class="skeleton-line short"></div>
          </div>
        </div>
      </div>

      <!-- No results -->
      <div class="no-results" *ngIf="!isLoading && filteredJobs.length === 0">
        <p>{{ 'userJobList.noJobsMatchFilters' | translate }}</p>
        <button class="clear-btn-primary" (click)="clearFilters()">{{ 'userJobList.clearFilters' | translate }}</button>
      </div>

      <!-- Job cards -->
      <div class="job-card" *ngFor="let job of filteredJobs" (click)="navigateToJob(job.id)">
        <!-- Company Logo -->
        <div class="company-logo" [style.background]="job.companyLogoUrl ? 'transparent' : job.companyColor">
          <img *ngIf="job.companyLogoUrl" [src]="job.companyLogoUrl" [alt]="job.company + ' logo'"
            class="company-logo-img" />
          <span *ngIf="!job.companyLogoUrl">{{ job.companyInitial }}</span>
        </div>

        <div class="job-body">
          <div class="company-name">{{ job.company }}</div>

          <div class="job-title-row">
            <h3 class="job-title">{{ job.title }}</h3>
            <span class="badge-new" *ngIf="job.isNew">{{ 'userJobList.newPost' | translate }}</span>
          </div>

          <div class="job-position mt-1" *ngIf="job.positionTitle">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="position-icon">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
            <span class="position-text">{{ job.positionTitle }}</span>
          </div>

          <!-- Meta row -->
          <div class="job-meta mt-1">
            <span class="meta-item">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M5.5 1C3.567 1 2 2.567 2 4.5c0 2.625 3.5 5.5 3.5 5.5S9 7.125 9 4.5C9 2.567 7.433 1 5.5 1z"
                  stroke="currentColor" stroke-width="1.2" fill="none" />
                <circle cx="5.5" cy="4.5" r="1.2" fill="currentColor" />
              </svg>
              {{ job.location }}
            </span>

            <span class="meta-dot"></span>

            <span class="meta-item">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                <circle cx="5.5" cy="5.5" r="4.5" stroke="currentColor" stroke-width="1.2" />
                <path d="M5.5 3v2.5l1.5 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
              </svg>
              {{ job.type }}
            </span>

            <ng-container *ngIf="job.workplace">
              <span class="meta-dot"></span>
              <span class="meta-item">
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                  <rect x="1.5" y="4" width="8" height="5.5" rx="1" stroke="currentColor" stroke-width="1.2" />
                  <path d="M3.5 4V3a2 2 0 014 0v1" stroke="currentColor" stroke-width="1.2" />
                </svg>
                {{ getWorkplaceLabel(job.workplace) }}
              </span>
            </ng-container>

            <ng-container *ngIf="!job.hideSalary && job.salaryMin !== null">
              <span class="meta-dot"></span>
              <span class="meta-item">
                {{ formatSalary(job.salaryMin ,job.currency) }} – {{ formatSalary(job.salaryMax,job.currency) }}
              </span>
            </ng-container>

            <span class="meta-dot"></span>
            <span class="meta-item time">{{ job.postedAgo }}</span>
          </div>

          <div class="job-desc mt-1" [innerHTML]="job.description"></div>
        </div>
      </div>

    </div><!-- /jobs -->
  </div><!-- /joblist-inner -->

  <!-- ═══════════════════════ MOBILE BOTTOM SHEET ════════════════════════ -->
  <div class="sheet-backdrop" [class.visible]="filtersOpen" (click)="closeFilters()"></div>

  <div class="bottom-sheet" [class.open]="filtersOpen">
    <div class="sheet-handle"></div>

    <div class="sheet-header">
      <h2 class="sheet-title">{{ 'userJobList.filters' | translate }}</h2>
      <button class="sheet-close-btn" (click)="closeFilters()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="sheet-body">

      <!-- Salary -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.salary' | translate }}</p>
        <div class="rate">
          <div *ngFor="let tab of ['Hourly','Monthly','Yearly']" [class.active]="activeSalaryTab === tab"
            (click)="setSalaryTab($any(tab))">{{ tab }}</div>
        </div>
        <div class="salary-checkboxes sheet-checkboxes">
          <label *ngFor="let opt of currentSalaryOptions" class="check-item">
            <input type="checkbox" [checked]="isSalarySelected(opt)" (change)="toggleSalaryRange(opt)" />
            <span class="checkmark"></span>
            <span class="check-label">{{ opt }}</span>
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Date of Posting -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.dateOfPosting' | translate }}</p>
        <div class="chip-group">
          <label *ngFor="let opt of dateOptions" class="chip-radio"
            [class.chip-active]="selectedDatePosting === opt.value">
            <input type="radio" name="sheetDatePosting" [value]="opt.value" [(ngModel)]="selectedDatePosting"
              (ngModelChange)="loadJobs()" />
            {{ opt.label }}
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Work Experience -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.workExperience' | translate }}</p>
        <div class="chip-group">
          <label *ngFor="let opt of experienceOptions" class="chip-radio"
            [class.chip-active]="selectedExperience === opt.value">
            <input type="radio" name="sheetExperience" [value]="opt.value" [(ngModel)]="selectedExperience"
              (ngModelChange)="loadJobs()" />
            {{ opt.label }}
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Type of Employment -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.typeOfEmployment' | translate }}</p>
        <div class="chip-group">
          <label *ngFor="let type of employmentOptions" class="chip-check"
            [class.chip-active]="isEmploymentSelected(type)">
            <input type="checkbox" [checked]="isEmploymentSelected(type)" (change)="toggleEmploymentType(type)" />
            {{ type }}
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Post Type -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.postType' | translate }}</p>
        <div class="chip-group">
          <label *ngFor="let opt of postTypeOptions" class="chip-radio"
            [class.chip-active]="selectedPostType === opt.value">
            <input type="radio" name="sheetPostType" [value]="opt.value" [(ngModel)]="selectedPostType"
              (ngModelChange)="loadJobs()" />
            {{ opt.label }}
          </label>
        </div>
      </div>

      <div class="divider"></div>

      <!-- Workplace -->
      <div class="filter-section">
        <p class="section-tittle">{{ 'userJobList.workplace' | translate }}</p>
        <div class="chip-group">
          <label *ngFor="let opt of workplaceOptions" class="chip-radio"
            [class.chip-active]="selectedWorkplace === opt.value">
            <input type="radio" name="sheetWorkplace" [value]="opt.value" [(ngModel)]="selectedWorkplace"
              (ngModelChange)="loadJobs()" />
            {{ opt.label }}
          </label>
        </div>
      </div>

    </div><!-- /sheet-body -->

    <div class="sheet-footer">
      <button class="sheet-btn-clear" (click)="clearFilters()">{{ 'userJobList.clearAll' | translate }}</button>
      <button class="sheet-btn-apply" (click)="closeFilters()">
        {{ 'userJobList.show' | translate }} {{ isLoading ? '…' : filteredJobs.length }} {{ 'userJobList.result' | translate }}{{ filteredJobs.length !== 1 ? 's' : '' }}
      </button>
    </div>
  </div><!-- /bottom-sheet -->

</div>
